
import React from "react";
import { Link2, ArrowRight } from "lucide-react";

interface BlockchainSpotlightProps {
  onNavigationClick?: (href: string) => void;
}

const BlockchainSpotlight: React.FC<BlockchainSpotlightProps> = ({ onNavigationClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigationClick) {
      onNavigationClick("/products/blockchain-smart-contracts");
    }
  };

  return (
    <div className="mt-3 w-full">
      <div className="flex items-center mb-4">
        <Link2 className="w-10 h-10 text-gray-900 mr-3" />
        <button 
          onClick={handleClick}
          className="text-2xl font-semibold text-gray-800 tracking-tight hover:text-blue-600 transition-colors text-left"
        >
          Blockchain Smart Contracts
        </button>
      </div>
      <span className="block text-base font-medium text-blue-600 mb-2 tracking-wide">
        Next-Gen Trust & Automation
      </span>
      <p className="text-sm text-gray-700 mb-4 leading-relaxed max-w-sm">
        Decentralised, tamper-proof business process automation and secure asset management.
      </p>
    </div>
  );
};

export default BlockchainSpotlight;
